import React, { Component } from 'react';
import {
    Paper,
    Typography,
    Link,
    CircularProgress,
} from '@material-ui/core';
import Dropzone from 'react-dropzone'
import { FlatButton } from 'shared/mui-styles';
import { InsertDriveFile, Error } from '@material-ui/icons';
import { formatBytes } from 'shared/helpers';
import Modal from 'shared/components/Modal';
import COLORS from 'shared/colors'
import * as consts from 'shared/consts.js';

const classes = {
    card: {
        width: '860px',
        padding: '2rem 3rem 3rem',
    },
    boldText: {
        fontWeight: '500',
    },
    marginBottom: {
        marginBottom: '.8rem',
    },
    marginBottomBig : {
        marginBottom: '2.2rem'
    },
    buttonProgress: {
        color: COLORS.THEME,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}

class UploadComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            showModal: false,
            modalTitle: '',
            modalMsg: '',
        }
    }

    componentDidMount() {
        const { fetchAgencyList } = this.props;
        fetchAgencyList();
    }

    componentDidUpdate(prevProps) {
        const { uploadError, uploadData } = this.props;
        const { file } = this.state;

        if (prevProps.uploadError !== uploadError && uploadError) {
            this.setState({
                showModal: true,
                modalTitle: 'File could not be uploaded.',
                modalMsg: uploadError
            })
        }

        if (prevProps.uploadData !== uploadData) {
            const message = `Your file ${file.name} has been successfully uploaded to the database. ${uploadData.data.new_properties} properties were added, ${uploadData.data.new_subsidies} subsidies were added, and ${uploadData.data.updated} records were modified.`

            this.setState({
                showModal: true,
                file: null,
                modalTitle: 'File successfully uploaded!',
                modalMsg: message
            })
        }
    }

    handleUpload = () => {
        const { uploadFile } = this.props;
        const { file } = this.state;

        uploadFile(file)
    }

    handleFileDrop = (acceptedFiles, rejectedFiles) => {
        this.setState({ file: acceptedFiles[0] })
    }

    closeModal = () => {
        const { clearUploadErrors } = this.props;

        this.setState({ showModal: false })
        clearUploadErrors();
    }

    render() {
        const { isUploading, agencyList, userAgencyID } = this.props;
        const { file, showModal, modalTitle, modalMsg } = this.state;

        const usersAgency = agencyList.filter(agency => agency.id === userAgencyID)
        const agencyName = usersAgency.length > 0 ? usersAgency[0].name : null;

        return (
            <div className="body-center">
                <Paper elevation={1} style={classes.card}>
                    <Typography style={{ textAlign: 'center', marginTop: '.8rem', marginBottom: '.8rem' }} variant="h5">
                        Upload to Database
                    </Typography>
                    <div style={{ padding: '1.2rem 4rem 0' }}>
                        <Typography style={{ ...classes.marginBottom, ...classes.boldText }} variant="body1">
                            File Requirements:
                        </Typography>
                        <div style={classes.marginBottom}>
                            <ul>
                                <li>
                                    <Typography variant="body1">
                                        Files must be in .csv or .xlsx format only
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body1">
                                        Headers, header order, and data types must match the template
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body1">
                                        For in-depth requirements please see <Link
                                            target="_blank"
                                            rel="noopener"
                                            href={consts.uploadDocumentationLink}
                                        >
                                            Upload Documentation
                                        </Link>
                                    </Typography>
                                </li>
                            </ul>
                        </div>
                        {agencyName && (
                            <Typography style={classes.marginBottom} variant="body1">
                                Please see and follow the template for your agency: <Link
                                    target="_blank"
                                    rel="noopener"
                                    href={require(`assets/data/templates/${agencyName} template.xlsx`)}
                                    download={`${agencyName} template.xlsx`}
                                >
                                    Data Format Template - {agencyName}
                                </Link>
                            </Typography>
                        )}
                    </div>
                    <Dropzone multiple={false} accept={["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]} onDrop={this.handleFileDrop}>
                        {({ getRootProps, getInputProps, isDragAccept, isDragReject }) => (
                            <div className="dropzone-container">
                                <div {...getRootProps({
                                        className: `dropzone ${isDragAccept ? 'accept' : ''} ${isDragReject ? 'reject' : ''}`
                                    })}>
                                    <input {...getInputProps()} />
                                    {isDragReject ? (
                                        <Error fontSize="large" />
                                    ) : (
                                        <InsertDriveFile fontSize="large" />
                                    )}
                                    <Typography style={{ fontWeight: '500', marginTop: '.8rem' }} variant="body1">{isDragReject ? 'File format is not valid.' : 'Click to choose a file or drag it here'}</Typography>
                                    <div className="filename-container">
                                        {file && (
                                            <Typography variant="body2">{file.path} - {formatBytes(file.size)}</Typography>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <div style={{ position: 'relative' }}>
                                        <FlatButton
                                            variant="contained"
                                            disabled={!file || isUploading}
                                            color="primary"
                                            onClick={this.handleUpload}
                                        >
                                            Upload
                                        </FlatButton>
                                        {isUploading && <CircularProgress size={24} style={classes.buttonProgress} />}
                                    </div>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </Paper>
                <Modal
                    maxWidth="sm"
                    visible={showModal}
                    title={modalTitle}
                    content={modalMsg}
                    onClose={this.closeModal}
                />
            </div>
        );
    }
}

export default UploadComponent;
